import axios from "../utils/axios";

import { ResetPasswordQuery, ResetPasswordType, SignInType, SignUpType } from "../types/auth";

export function signIn(credentials: SignInType, remember: boolean) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/auth/token/`, credentials)
      .then((response) => {
        if (response.status === 201) {
          if (remember) {
            localStorage.setItem('user', JSON.stringify(response.data));
          }
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function signUp(credentials: SignUpType) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/auth/sign-up", credentials)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function resetPassword(credentials: ResetPasswordType) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/users/password-recovery/`, credentials)
      .then((response) => {
        if (response.status < 400) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function createNewPassword(data: ResetPasswordQuery) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/users/password-recovery-confirmation/`, data)
      .then((response) => {
        if (response.status < 400) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
